import { GQLCategories } from "@gql/types/gql";
import FreeQuotePopup from "@components/shared/freeQuotePopup";
import Introduction from "@components/shared/introduction";
import BestBuyers from "@components/shared/bestBuyers";
import { useQuery } from "@tanstack/react-query";
import { ICategoryByIdPageProps } from "@genericTypes/sharedTypes";
import RecentPostsMobile from "@components/shared/recentPostsMobile";

export default function OverView({
    category,
    categoryId,
    listOfContentsMobile,
    recentPostsMobile,
}: {
    category: GQLCategories;
    categoryId: number;
    listOfContentsMobile: { title: string | null; link: string }[];
    recentPostsMobile: { title: string | null; link: string }[];
}) {
    const { data: props } = useQuery<ICategoryByIdPageProps>([
        "categoryPageProps",
    ]);
    const { offers } = props ?? {};

    return (
        <section className="lg:w-2/3 lg:px-0 mt-9 lg:mt-0">
            <FreeQuotePopup category={category} />

            <Introduction
                category={category}
                listOfContentsMobile={listOfContentsMobile}
            />
            {!!offers?.length && (
                <BestBuyers buyers={offers} categoryId={categoryId} />
            )}
            {recentPostsMobile?.length > 0 && (
                <RecentPostsMobile links={recentPostsMobile} />
            )}
        </section>
    );
}
